export enum UserRole {
    NOT_DEFINED,
    SUPER_ADMIN,
    ADMIN,
    USER,
}
